import { formatISO, startOfDay, sub } from 'date-fns';
import { useMemo } from 'react';

import { type AssetSearchFilters } from '@air/api/types';

import { usePrivateWorkspaceAgentPanelSession } from '~/components/v2/components/workspace/workspace-agent-panel/PrivateWorkspaceAgentPanelProvider';
import { usePrivateWorkspaceAgentPromptCardClipsSearch } from '~/components/v2/components/workspace/workspace-agent-panel/queries/usePrivateWorkspaceAgentPromptCardClipsSearch';
import { toWorkspaceAgentPromptCardThumbnails } from '~/components/v2/components/workspace/workspace-agent-panel/utils/toWorkspaceAgentPromptCardThumbnails';

export const usePrivateWorkspaceAgentNewUploadsPromptCard = () => {
  const { workspaceId } = usePrivateWorkspaceAgentPanelSession();
  const createdStart = formatISO(startOfDay(sub(new Date(), { weeks: 1 })), { representation: 'complete' });
  const filters = useMemo(
    (): AssetSearchFilters => ({
      created: { start: createdStart },
      untagged: { is: true },
    }),
    [createdStart],
  );

  const { data, isLoading } = usePrivateWorkspaceAgentPromptCardClipsSearch({
    filters,
    workspaceId,
  });

  const clips = data?.data.clips;
  const thumbnails = useMemo(() => toWorkspaceAgentPromptCardThumbnails(clips ?? []), [clips]);
  const total = data?.data.total ?? 0;

  return {
    isPending: isLoading,
    thumbnails,
    total,
  };
};
